import "./styles/invivo.css";

import { createInvivoApp } from "./app/create_invivo_app";
import { getSelectedSceneSlugFromUrl } from "./app/scene_selection";

async function bootInvivo(): Promise<void> {
  const canvas = document.getElementById("invivo-canvas");

  if (!(canvas instanceof HTMLCanvasElement)) {
    throw new Error("InVivo canvas was not found.");
  }

  const app = await createInvivoApp({
    canvas,
    sceneSlug: getSelectedSceneSlugFromUrl(window.location.href),
  });

  window.addEventListener(
    "beforeunload",
    () => {
      app.dispose();
    },
    { once: true }
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    void bootInvivo();
  });
} else {
  void bootInvivo();
}
